import React from 'react';
import HomeNavBar from "../components/HomeNavBar"
import TutorRegisterForm from '../forms/TutorRegisterForm';
import backgroundImg from '../assets/images/background.jpg';

// Content Section Component
const ContentSection = () => {
  return (
    <div style={{
      borderRadius: '10px',
      padding: '2rem',
      margin: '1rem 0'
    }}>
      <h1 style={{
        fontSize: '3.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        color: '#fff'
      }}>Join Our Tutoring Network</h1>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Register as a tutor on our platform and connect with students seeking academic support. Whether you're a current student or an experienced educator, our platform provides the tools you need to offer your tutoring services effectively.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Our platform offers secure payment processing, scheduling tools, and direct communication channels with students and educational institutions. Join hundreds of tutors already making a difference in students' academic journeys.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Start your registration process today and become part of our trusted tutoring network. Complete verification ensures credibility and increases opportunities to connect with students who need your expertise.
      </p>
    </div>
  );
};

// Main TutorRegisterPage Component
const TutorRegisterPage = () => {
  return (
    <div>
      {/* Bootstrap 5 CSS Link */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        {/* Navigation */}
        <HomeNavBar />

        {/* Hero Section */}
        <section style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${backgroundImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div className="container">
            <div className="row">
              {/* Form Section (1/3) - Left side */}
              <div className="col-lg-4">
                <TutorRegisterForm />
              </div>

              {/* Content Section (2/3) - Right side */}
              <div className="col-lg-8">
                <ContentSection />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Bootstrap 5 JS Script */}
      <script 
        src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"
      ></script>
    </div>
  );
};

export default TutorRegisterPage;
